import BaseComponent from '@utils/base.js';

import * as styles from './controlBtn.module.scss';

/** @extends {BaseComponent<HTMLButtonElement>} */
export default class ControlBtn extends BaseComponent {
  /** @param {Props<HTMLButtonElement>} props */
  constructor(props) {
    super({
      elementTag: 'button',
      classes: [styles.control],
      text: props.text,
    });

    if (props.classes) this.addClasses(...props.classes);
  }
}
